/* eslint-disable no-console,no-undef, camelcase, no-constant-condition */
import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import _ from "lodash";
// import Datetime from "react-datetime";
import { connect } from "react-redux";
import { toast } from "react-toastify";
// import { DateIconContainer } from "../CreateEvent/styles";
// import RadioButton from "../CustomRadioButton";
import Waiting from "../Waiting";
import {
  // getOrientation,
  // resetOrientation,
  convertDateInTimezone,
  // checkImage,
  getPermissionStatus,
  fetchApi,
} from "../../utils/methods";
import { ImageUrl, /*imageErrorMessage,*/ TimeZone } from "../../utils/constants";
import { eventsTierPoints, recurringTypes, wellnessChallengePoints, /* eventsTierPoints */ } from "../../../mockData";
import { getAllCompanies } from "../../redux/actions/challengeActions";
import { getUserCompanyDetails } from "../../redux/actions/userProfileActions";
import { EditEventAction, getCompanyDepartment, getEventDetailsById } from "../../redux/actions";
import timezones from "../../../timezones.json";
import {
  Layout,
  // ChallengeHeading,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  // UploadPhotoContainer,
  // RemoveImage,
  // InputImage,
  // CustomTextArea,
  ButtonContainer,
  CustomRadioButton,
  // StyledLabelV2,
  // StyledDateTime,
  Locationwrapper,
  // Heading,
  // InputContainerV2,
  EditorContainer,
  // FlayerMain,
  SearchDropDown,
  // RemoveImageV2,
  // CircleNew,
  // MUICalendarWrapper,
} from "../CreateEvent/style";
import { Main, /*ToolTip*/ } from "../AdminTeamCreation/styles";
// import StepsHeading from "../CreateEvent/stepNames";
import StepsHeading from "../RecogntionAdmin/corevalues/stepNames";
import { TitleContainer, /*FieldTitle*/ } from "../AdminTeamCreation/styles";
// import { StyledSvg } from "../MainEvents/styles";
import Editor from "../CKEditor";
import Select from "react-select";
import { getCompanyLocation } from "../../redux/actions";
// import HoverButton from "../common/HoverButton";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
// import { ActivityDropdown } from "../CreateChallengeForm/styles";
// import CommonButton from "../common/CommonButton/CommonButton";
import { withTranslation } from "react-i18next";
import { /*Arrows,*/ CalendarBranding, /*CalendarIcon,*/ /*NextArrows,*/ RecognitionCloseIcon, RecognitionTickIcon, /*SearchButtonIcon,*/ UploadHDMIcon, UploadIcon, closeIcon } from "../../utils/icons";
import { Border } from "../Journeys/styles";
// import CircularProgressBar from "../CreateEvent/circularProgressBar";
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
// import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { SearchFilter1 } from "../PeopleHomeV2/styles";
import { http } from "../../redux/http";
import { EditEventAPI, GetCompanyInfo, GetTeams } from "../../redux/constants/apiConstants";
import { FetchCoaches } from '../../redux/constants/apiConstants';
import { BASE_URL } from "../../utils/config";
// import { NewActivityDropdownCommon } from '../common/CommonDropDown/style';
// import { Dropdown } from "react-bootstrap";
import { DateCard, FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { RadioButtonWrapper,RadioButton } from "../RecogntionAdmin/styles";
import { t } from "i18next";
import { CommonButtonBorder } from "../common/commonStyles";
import { DateCalendarWrapper } from "../ChallengeDetailsV2/StartChallengePopUp/styles";
import CustomDateTimePicker from "../common/DateRangePicker/CustomDateTimePicker";

dayjs.extend(utc)
dayjs.extend(timezone)

class EditEvent extends Component {
  constructor(props) {
    super();
    let updatedTiers = eventsTierPoints;
    props.role === "WELLNESS_CHAMPION" && updatedTiers.splice(3);
    this.state = {
      imgSrc: "",
      title: "",
      date: dayjs(),
      endDate: dayjs(),
      location: "",
      description: "",
      imageName: "",
      time: dayjs().format("hh:mm a"),
      endTime: dayjs().format("hh:mm a"),
      showDateTimeInput: "",
      selectedMenu: "Select an option",
      showPlaces: true,
      eventThemePointValue:null,
      participantingPointValue:null,
      amigosToInvite: [],
      openDateTimePicker: "",
      eventLink: "",
      companies: [],
      com_location: [],
      eventPointValue: "",
      limitUser: "0",
      addLimitCheckbox: false,
      isSpouse: false,
      isDependent: false,
      isEmployee: false,
      selectedOption: 0,
      eventPointKey: "Tier 1: 0 points",
      emailOption: {
        launch_event_email: 0,
        event_reminder_email: 0,
        event_complete_email: 0,
      },
      eventPoints: updatedTiers,
      time_zone: TimeZone === "Asia/Calcutta" ? "Asia/Kolkata" : TimeZone,
      companiesPermission: false,
      locationPermission: false,
      recurringEvent: recurringTypes[0],
      eventLimitValue: 0,
      step: 1,
      so: true,
      selectedCompanyValue: "",
      selectedCompanyCheckBox: 0,
      dropdown: true,
      showBack: false,
      buttonClickScrollTop: false,
      flayerName: "",
      flayerValue: "",
      progress: 0,
      selectFlayer: 1,
      menuIsOpen: false,
      selectedLocation: [],
      selectedCompany: [],
      editImage: "",
      usersToInvite:0,
      allTeams:[],
      filteredCompanies:[],
      searchTerm: '',
      teams:[],
      getCoachData: [],
      so3: false,
      coachName: '',
      coachId: null,
      companyInfo:null,
      showFrequency: true,
      launch:1,
      datePopup: null,
      showDatePopupModal: false,
      isThemeEvent:false,
    };
  }

  eventsTierPoints=[
    {"key": "Tier 1: 0 points", "value": 0},
    {"key": "Tier 2: 25 points", "value": 25},
    {"key": "Tier 3: 50 points", "value": 50},
    {"key": "Tier 4: 100 points", "value": 100},
    { "key": "Tier 5: 150 points", "value": 150 },
    { "key": "Tier 6: 200 points", "value": 200 },
    { "key": "Tier 7: 250 points", "value": 250 },
    { "key": "Tier 8: 300 points", "value": 300 },
    { "key": "Tier 9: 350 points", "value": 350 },
    { "key": "Tier 10: 400 points", "value": 400 },
    { "key": "Tier 11: 450 points", "value": 450 },
    { "key": "Tier 12: 500 points", "value": 500 },
    { "key": "Tier 13: 550 points", "value": 550 },
    { "key": "Tier 14: 600 points", "value": 600 },
    { "key": "Tier 15: 650 points", "value": 650 },
    { "key": "Tier 16: 700 points", "value": 700 },
    { "key": "Tier 17: 750 points", "value": 750 },
    { "key": "Tier 18: 800 points", "value": 800 },
    { "key": "Tier 19: 850 points", "value": 850 },
    { "key": "Tier 20: 900 points", "value": 900 },
    { "key": "Tier 21: 950 points", "value": 950 },
    { "key": "Tier 22: 1000 points", "value": 1000 },
  ]

  componentDidMount() {
    const companiesPermission = getPermissionStatus(
      "Show companies in event",
      this.props.userPermissions
    );
    if (companiesPermission||this.props.isAccountManager) {
      if (!this.props.allCompanies) {
        this.props.fetchAllCompanies();
      }
    } else {
      this.props.fetchCompanyForUser();
      this.setState({
        companies: this.props.userCompany && [this.props.userCompany.id],
      });
    }
    document.addEventListener("mousedown", this.handleClick);

    const { history, eventDetail,EventDetailsById } =
      this.props;

    if(eventDetail?.event_type==="theme")
    {
      this.setState({isThemeEvent:true})
    }

    const { pathname } = history.location;
    const arr = pathname.split("/");
    this.fetchCoachData();
    if (!eventDetail || _.isEmpty(eventDetail)) {
      EventDetailsById(arr[arr.length - 2]);
      // history.push(`/events/${arr[arr.length - 2]}`);
    } else {
      this.setEventDetails();
    }
  }

  setEventDetails = ()=>{
    const companiesPermission = getPermissionStatus(
      "Show companies in event",
      this.props.userPermissions
    );
    const locationPermission = getPermissionStatus(
      "Show locations in event",
      this.props.userPermissions
    );
    const { eventDetail, allCompanies, getCompanyLocation } =
    this.props;
    let TierPointsIndex = this.state.eventPoints.findIndex(
      (data) => data.value == _.get(eventDetail, "event_points", 10)
    );
    const eventTimezone = eventDetail.time_zone
      ? eventDetail.time_zone: TimeZone === "Asia/Calcutta"? "Asia/Kolkata": TimeZone;
    this.setState({
      eventId: eventDetail.id,
      imgSrc: `${ImageUrl}/${eventDetail.image}`,
      editImage: eventDetail.image,
      title: eventDetail.title,
      date: dayjs.utc(eventDetail.start_date).tz(eventTimezone),
      endDate: dayjs.utc(eventDetail.end_date).tz(eventTimezone),
      location: eventDetail.event_location || "",
      description: eventDetail.body,
      imageName: eventDetail.image,
      time: moment
        .utc(eventDetail.start_date)
        .tz(eventTimezone)
        .format("hh:mm a"),
      endTime: moment
        .utc(eventDetail.end_date)
        .tz(eventTimezone)
        .format("hh:mm a"),
      eventLink: eventDetail.event_link || "",
      selectedOption: eventDetail.event_location ? 0 : 1,
      companies: eventDetail.event_companies
        .split(",")
        .map((value) => parseInt(value,10)),
      selectedCompany: eventDetail.event_companies
        .split(",")
        .map((value) => parseInt(value,10)),
      eventPointValue: TierPointsIndex === -1 ? 10 : eventDetail.event_points,
      apiChecker:
        convertDateInTimezone(eventDetail.start_date)._d < moment()._d &&
        convertDateInTimezone(eventDetail.end_date)._d >= moment()._d
          ? true
          : false,
      com_location: eventDetail.event_city_states
        ? eventDetail.event_city_states.split(",").map((value) => parseInt(value,10)): [],
      selectedLocation: eventDetail.event_city_states
        ? eventDetail.event_city_states.split(",").map((value) => parseInt(value,10))
        : [],
      isSpouse: eventDetail.spouse,
      isDependent: eventDetail.dependent,
      isEmployee: false || !eventDetail.is_spouse_or_dependent,
      eventPointKey:
        eventsTierPoints[TierPointsIndex === -1 ? 0 : TierPointsIndex].key,
      time_zone: eventTimezone,
      emailOption: {
        launch_event_email: eventDetail.launch_event_email,
        event_reminder_email: eventDetail.event_reminder_email,
        event_complete_email: eventDetail.event_complete_email,
      },
      recurringEvent: eventDetail.is_recurring_event
        ? eventDetail.recurring_type
        : recurringTypes[0],
      eventLimitValue: eventDetail.recurring_event_limit,
      flayerValue: eventDetail.event_flyer,
      flayerName:
        eventDetail && eventDetail.event_flyer && eventDetail.event_flyer.length > 0 ? "Flyer" : "",
      selectFlayer:eventDetail&&eventDetail.event_flyer &&eventDetail.event_flyer.length>0?0:1,
      selectedCompanyCheckBox:
        eventDetail && eventDetail.is_global_event ? 0 : 1,
      usersToInvite: eventDetail?.is_team_event ? 3 : eventDetail?.event_city_states ? 2 :eventDetail?.event_departments ? 1 : 0,
      teams:eventDetail?.event_teams ? eventDetail?.event_teams?.split(",").map((value) => parseInt(value,10)): [],
      presentTeams:eventDetail?.event_teams ? eventDetail?.event_teams?.split(",").map((value) => parseInt(value,10)): [],
      departments:eventDetail?.event_departments ? eventDetail?.event_departments?.split(",").map((value) => parseInt(value,10)): [],
      presentDepartments:eventDetail?.event_departments ? eventDetail?.event_departments.split(",").map((value) => parseInt(value,10)): [],
      showDateTimeInput: eventDetail.is_all_day_event ? "date" : "",
      coachId: eventDetail?.coach_id?eventDetail?.coach_id:null,
      coachName:!eventDetail?.coach_id && "None",
      isThemeEvent:eventDetail?.event_type==="theme"?true:false,
      eventThemePointValue:eventDetail?.event_type==="theme"?eventDetail?.event_points:null,
      participantingPointValue:eventDetail?.event_type==="theme"?eventDetail?.moment_points:null, 

      // teams:eventDetail.event_teams ? eventDetail.event_teams.split(",").map((value) => parseInt(value,10)): [],
    });
    if (eventDetail.user_limit) {
      this.setState({
        addLimitCheckbox: true,
        limitUser: eventDetail.user_limit,
      });
    }
  
    this.setState({
      companiesPermission: companiesPermission,
      locationPermission: locationPermission,
    });
   
    if (allCompanies) {
      allCompanies &&
        allCompanies.map((company) => {
          if (company.id == eventDetail.event_companies) {
            this.setState({
              selectedCompanyValue: company.company_name,
            });
          }
        });
    }
    if (
      eventDetail &&
      eventDetail.is_global_event === 0 &&
      eventDetail.event_companies
    ) {
      getCompanyLocation(eventDetail.event_companies);
    }
   
    const{getCompanyDepartment}=this.props;
    
   
    if(eventDetail.is_team_event){
      this.getTeams(eventDetail.event_companies);
   
    }else if(eventDetail.event_departments){
      getCompanyDepartment(eventDetail.event_companies);
   
    }
   
    if(!eventDetail.is_global_event){
      this.getCompanyInfo(eventDetail.event_companies);
    }

  }

  getCompanyInfo = async(companyId)=>{
    let apiUrl = GetCompanyInfo + "/" + companyId;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res.status === "success") {
        this.setState({companyInfo: res?.data?.companyInfo?.[0]})

      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  changeLimitCheckBox = (value) => {
    this.setState({
      addLimitCheckbox: value,
    });
  };

  checkBase64(image) {
    if (image) {
      let arr = image.split("/");
      if (arr[0] !== "event-image") {
        return true;
      } else {
        return false;
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { eventDetail, allCompanies } = this.props;
    if(eventDetail!= prevProps?.eventDetail){
      this.setEventDetails();
    }
    this.state.flayerName &&
      this.state.progress < 100 &&
      setTimeout(this.progress, 1000);
    if (allCompanies && this.state.selectedCompanyValue.length === 0) {
      allCompanies &&
        allCompanies.map((company) => {
          if (company.id == eventDetail.event_companies) {
            this.setState({
              selectedCompanyValue: company.company_name,
            });
          }
        });
    }
    if (this.state.buttonClickScrollTop) {
      window.scrollTo(0, 0);
      window.setTimeout(() => {
        this.setState({ buttonClickScrollTop: false });
      }, 2000);
    }

    if (
      !this.state.companiesPermission &&
      this.props.userCompany !== prevProps.userCompany
    ) {
      this.setState({
        companies: this.props.userCompany && [this.props.userCompany.id],
      });
    }

    if(prevProps.allCompanies != this.state.filteredCompanies){
      this.setState({filteredCompanies:this.props.allCompanies})
    }

    const { getCoachData, coachName } = this.state;
    if( eventDetail?.coach_id && getCoachData.length>0 && !coachName){
      const coachData = getCoachData?.find((coach) => coach?.id == eventDetail?.coach_id);
      if(!coachName){
        this.setState({coachName:coachData?.name})
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
  }

  fetchCoachData = async () => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let url = BASE_URL + FetchCoaches;
    await fetch(url, { method: "GET", headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            if(data.status === 'success'){
              let coaches = data.data;
              coaches.unshift({id:null,name:"None"}); 
              this.setState({getCoachData: coaches });
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    this.setState({ searchTerm: value });

    const filtered = this.props.allCompanies.filter((company) =>
      company.company_name.toLowerCase().includes(value)
    );

    this.setState({ filteredCompanies: filtered });
  };

  progress = () => {
    this.setState({ progress: this.state.progress + 20 });
  };

  removePDF = () => {
    this.setState({
      flayerValue: null,
      flayerName: null,
      progress: 0,
    });
  };

  uploadPDFFile = (baseImage,imageName) => {
    this.setState({
      flayerValue: baseImage,
      flayerName: imageName,
    });
  };

  // uploadPDFFile = (e) => {
  //   let file = e.target.files[0];
  //   if (file) {
  //     let fileArr = file.name.split(".");
  //     if (
  //       fileArr[fileArr.length - 1].toUpperCase() == "PNG" ||"PDF" ||"JPEG" || "JPG"
  //     ) {
  //       if (file?.size / 1000000 <= 10) {
  //         let reader = new FileReader();
  //         reader.readAsDataURL(file);
  //         reader.onloadend = () => {
  //           this.setState({
  //             flayerValue: reader.result,
  //             flayerName: file.name,
  //           });
  //         };
  //       } else {
  //         toast.error("Please select PDF file less than 10MB");
  //         document.getElementById("event-upload-file").value = "";
  //       }
  //     } else {
  //       toast.error("Please select PDF file");
  //       document.getElementById("event-upload-file").value = "";
  //     }
  //   } else {
  //     this.changeLoader(false);
  //     document.getElementById("event-upload-file").value = "";
  //   }
  // };

  onChangeLocation = (id) => {
    const { com_location } = this.state;

    if (com_location.includes(id)) {
      let index = com_location.findIndex((item) => item === id);
      if (index > -1) {
        com_location.splice(index, 1);
      }
    } else {
      com_location.push(id);
    }
    this.setState({
      com_location: com_location,
    });
  };

  onChangeDepartment = (id) => {
    const { departments } = this.state;
    if (departments.includes(id)) {
      let index = departments.findIndex((item) => item === id);
      if (index > -1) {
        departments.splice(index, 1);
      }
    } else {
      departments.push(id);
    }
    this.setState({
      departments: departments,
    });
  };

  onChangeTeam = (id) => {
    const { teams } = this.state;
    if (teams.includes(id)) {
      let index = teams.findIndex((item) => item === id);
      if (index > -1) {
        teams.splice(index, 1);
      }
    } else {
      teams.push(id);
    }
    this.setState({
      teams: teams,
    });
  };

  onChangeTimeZone = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  handleClick = (e) => {
    if (this.datePickerWrapper && !this.datePickerWrapper.contains(e.target)) {
      this.setState({
        openDateTimePicker: "",
      });
    }
  };

  setDatePickerWrapper = (node) => {
    if (!this.state.apiChecker) {
      this.datePickerWrapper = node;
    }
  };

  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
      editImage:baseImage
    });
  }

  // onChange = (e) => {
  //   let file = e.target.files[0];
  //   if (checkImage(e.target.files)) {
  //     if (file?.size / 1000000 <= 20) {
  //       let reader = new FileReader();
  //       reader.readAsDataURL(file);
  //       const array = document
  //         .getElementById("event-upload-file")
  //         .value.split("\\");
  //       reader.onloadend = () => {
  //         this.setState({
  //           imgSrc: reader.result,
  //           imageName: array[array.length - 1],
  //           editImage: reader.result,
  //         });
  //         getOrientation(file, (or) => {
  //           resetOrientation([reader.result], or, (baseImage) => {
  //             this.setState({
  //               imgSrc: baseImage,
  //               editImage: baseImage,
  //             });
  //           });
  //         });
  //       };
  //     } else {
  //       toast.error("Please select image file less than 20MB");
  //       document.getElementById("event-upload-file").value = "";
  //     }
  //   } else {
  //     toast.error(imageErrorMessage);
  //     document.getElementById("event-upload-file").value = "";
  //   }
  // };

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  removePhoto = () => {
    // document.getElementById('edit-event-file').value = '';
    this.setState({
      imgSrc: "",
      imageName: "",
      editImage: "",
    });
  };

  changeDateTimeView = (value) => {
    if (value === "date") {
      this.setState({
        date: dayjs(),
        endDate: dayjs().add(1, 'day'),
        showDateTimeInput: value,
        allDayEvent: 1,
        showFrequency: false,
      });
    } else {
      this.setState({
        date: dayjs(),
        endDate:  dayjs().add(1, 'day'),
        showDateTimeInput: "",
        allDayEvent: 0,
        showFrequency: true,
      });
    }
  };

  onSelect = (value) => {
    this.setState({
      selectedMenu: value,
    });
  };

  // onSelectPoints = (name, value, key) => {
  //   this.setState({
  //     [name]: value,
  //     eventPointKey: key,
  //   });
  // };

  onSelectPoints = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventPointValue: name.value,
    });
  };

  onSelectPointsThemeEvent = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventThemePointValue: name.value,
    });
  };


  onSelectPointsParticipation = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      participantingPointValue: name.value,
    });
  };

  changeDate = (e, stateName) => {
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === "date") {
      this.setState({
        date: moment(e._d).format("MM/DD/YYYY"),
        time: moment(e._d).format("hh:mm a"),
        endDate: moment(e._d).format("MM/DD/YYYY"),
        endTime: "11:59 pm",
        openDateTimePicker: "",
      });
    } else if (stateName.includes("ate")) {
      this.setState({
        openDateTimePicker: "",
        [stateName]: moment(e._d).format("MM/DD/YYYY"),
      });
    } else {
      this.setState({
        [stateName]: moment(e._d).format("hh:mm a"),
        openDateTimePicker: stateName,
      });
    }
  };

  onChangeDate = (e, stateName) => {
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === "date") {
      this.setState({
        date: dayjs(e),
        time: dayjs(e).format("hh:mm a"),
        endDate: dayjs(e).add(2, 'day'),
        endTime: "11:59 pm",
        openDateTimePicker: "",
      });
    } else if (stateName.includes("ate")) {
      this.setState({
        openDateTimePicker: "",
        [stateName]: dayjs(e),
      });
    } else {
      this.setState({
        [stateName]: e,
        openDateTimePicker: stateName,
      });
    }
  };

  showDatePicker = (value) => {
    if (this.state.openDateTimePicker === value) {
      this.setState({
        openDateTimePicker: "",
      });
    } else {
      this.setState({
        openDateTimePicker: value,
      });
    }
  };

  onCheckboxChange = (element) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      let index = companies.findIndex((item) => item === element);
      if (index > -1) {
        companies.splice(index, 1);
      }
    } else {
      companies.push(element);
    }
    this.setState({
      companies: companies,
    });
  };
  onChangeEmail = (key) => {
    const { emailOption } = this.state;
    emailOption[key] = emailOption[key] === 0 ? 1 : 0;
    this.setState({ emailOption: emailOption });
  };

  selectAllCompanies = (e) => {
    e.preventDefault();
    let invitedCompanies = [];
    const { allCompanies } = this.props;
    if (this.state.companies.length === allCompanies.length) {
      invitedCompanies = [];
    } else {
      allCompanies.map((company) => {
        invitedCompanies.push(company.id);
      });
    }
    this.setState({
      companies: invitedCompanies,
    });
  };

  onLocationChange = (e) => {
    const { getPlacesAction } = this.props;
    this.setState(
      {
        location: e.target.value,
        showPlaces: true,
      },
      () => {
        if (this.state.location.length > 3 && this.state.location.trim() != "")
          getPlacesAction(this.state.location.trim());
      }
    );
  };

  setLocation = (location) => {
    this.setState({
      location: location,
      showPlaces: false,
    });
  };

  // onSelectCategory = (name, value) => {
  //   this.setState({
  //     [name]: value,
  //   });
  // };

  onSelectCategory = (name, value) => {
    this.setState({
      [name]: value
    });
    if(name !== 'time_zone')
    {
      this.setState({
        eventLimitValue: name,
      });
    }
  };

  renderPlaces = (places) =>
    places.map((place, index) => (
      <div key={index} onClick={() => this.setLocation(place.description)}>
        <span>{place.description}</span>
      </div>
    ));

  saveEvent = () => {
    // e.preventDefault();
    const {
      apiChecker,
      com_location,
      eventId,
      title,
      date,
      description,
      // time,
      endDate,
      // endTime,
      location,
      eventLink,
      companies,
      eventPointValue,
      addLimitCheckbox,
      limitUser,
      selectedOption,
      time_zone,
      emailOption,
      locationPermission,
      recurringEvent,
      eventLimitValue,
      flayerValue,
      editImage,
      usersToInvite,
      departments,
      teams,
      coachId,
      selectFlayer,
      isThemeEvent,
      eventThemePointValue,
      participantingPointValue
      
    } = this.state;
    const { /*EditEventAction,*/ companyDetails } = this.props;
    let isRecurringEvent = recurringEvent === recurringTypes[0] ? 0 : 1;
    const EventDetails = {
      title,
      companies: companies,
      body: description,
      image: editImage,
      end_date:dayjs(endDate).format("YYYY-MM-DD") + " " + dayjs(endDate, "hh:mm a").format("HH:mm:ss"),
      start_date:dayjs(date).format("YYYY-MM-DD") + " " + dayjs(date, "hh:mm a").format("HH:mm:ss"),
      event_location: isThemeEvent ? null : !selectedOption ? location : null,
      event_link:  isThemeEvent ? null : selectedOption ? eventLink : null,
      id: eventId,
      event_points: isThemeEvent ? eventThemePointValue : eventPointValue,
      imageUpdated: this.checkBase64(editImage) ? 1 : 0,
      time_zone: time_zone,
      ...emailOption,
      is_recurring_event: isRecurringEvent,
      recurring_type: isRecurringEvent ? recurringEvent : null,
      recurring_event_limit: isRecurringEvent ? eventLimitValue : 0,
      event_flyer: selectFlayer==0? flayerValue:null,
      company_city_states: com_location,
      // coach:coachId,
      coach:  isThemeEvent ? null : coachId,
      event_for_spouse: this.state.isSpouse ? 1 : 0,
      event_for_dependent:this.state.isDependent ? 1 : 0,
      moment_points: isThemeEvent ? participantingPointValue : null ,
      event_type:  isThemeEvent ?  "theme" : null,
    };

    if (locationPermission) {
      // EventDetails.company_city_states = com_location;
      EventDetails.event_for_spouse = this.state.isSpouse;
      EventDetails.event_for_dependent = this.state.isDependent;
      if (this.props.locationDetails && this.props.locationDetails.length > 0) {
        if((com_location && com_location.length > 0)){
          (EventDetails.is_for_employee = 1)
        }else{
          (EventDetails.is_for_employee = 0)
        }
      } else {
        if (companyDetails["spouse_or_dependent"]) {
          EventDetails.is_for_employee = this.state.isEmployee ? 1 : 0;
        } else {
          EventDetails.is_for_employee = 1;
        }
      }
    }

    if (apiChecker) {
      EventDetails.is_event_started_or_over = 1;
    }
    if (addLimitCheckbox) {
      EventDetails.user_limit = limitUser;
    }

    if(usersToInvite === 0){
      EventDetails.company_departments = null;
      EventDetails.company_city_states = null;
      EventDetails.teams = null;
      EventDetails.is_for_employee = 1;
    }else if(usersToInvite === 1){
      EventDetails.company_departments = departments;
      EventDetails.company_city_states = null;
      EventDetails.teams = null;
      EventDetails.is_for_employee = 0;
    }else if(usersToInvite === 2){
      EventDetails.company_departments = null;
      EventDetails.company_city_states = com_location;
      EventDetails.teams = null;
      EventDetails.is_for_employee = 0;
    }else if(usersToInvite === 3){
      EventDetails.teams = teams;
      EventDetails.is_team_event=1;
      EventDetails.company_departments = null;
      EventDetails.company_city_states = null;
      EventDetails.is_for_employee = 0;
    }
    this.PostEvent(EventDetails);
  };

  PostEvent = async(payload)=>{

    this.setState({
      buttonStatus: true,
    });
    
    try{

      const res = await fetchApi(EditEventAPI, "PUT",payload);

      if(res?.data?.message){
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
        });
      }else{
        toast.success(res.data[0]);
        this.props.history.push(`/company/events/${this.state.eventId}`);
        this.setState({
          buttonStatus: false,
        });
      }

    }catch(error){
      toast.error(error);
      this.setState({
        buttonStatus: false,
      });

    }
  }

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
  };

  toggleRadioButton = (e) => {
    this.setState({ selectedOption: e });
    if (e === 1) {
      this.setState({ location: "" });
    } else {
      this.setState({ eventLink: "" });
    }
  };
  inviteToggleButton = (e) => {
    this.setState({
      usersToInvite: e,
      // companies: [],
      // selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({
        // city_location: [],
      });
    }
  };

  launchToggleButton = (e) => {
    this.setState({
      launch: e,
      // companies: [],
      // selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({
        // city_location: [],
      });
    }
  };
  

  wellnessCategories = [
    {
      name: "Nutrition Challenge",
      value: "nutrition",
    },
    {
      name: "Fitness Challenge",
      value: "fitness",
    },
    {
      name: "Workplace Challenge",
      value: "workplace",
    },
    {
      name: "Stress Challenge",
      value: "stress",
    },
    {
      name: "Health Challenge",
      value: "health",
    },
    {
      name: "Lifestyle Challenge",
      value: "lifestyle",
    },
  ];

  onSelectLocation = (name, value, id) => {
    this.setState({
      [name]: value,
    });
    this.props.getCompanyLocation(id);
    this.props.getCompanyDepartment(name.id);
    this.getTeams(name.id);
    this.getCompanyInfo(name.id);
  };

  getTeams = async(companyId)=>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetTeams}/${companyId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  eventButtonStatusHover = () => {
    this.setState({
      showBack: true,
    });
  };

  eventButtonStatus = () => {
    this.setState({
      showBack: false,
    });
  };

  removeHtmlTags = (str) => str.replace(/<[^>]*>/g, "");

  close = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  );

  redirect = () => {
    this.props.history.goBack();
    // this.props.history.push(`/events/${this.props.eventDetail.id}`);
  };

  renderHeading = () => (
    <>
      <FormHeading color={"#184A61"}>
        <div className="close-icon" onClick={()=>this.redirect() }>
          <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
        </div>
        { this.state.isThemeEvent ?  this.props.t("Edit Theme Event") :  this.props.t("Edit Live Event")}
      </FormHeading>
    </>
  );

  stepOneForm = () => {
    const {
      title,
      description,
      step,
    } = this.state;
    const charCount = description?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')?.trim().length;
    

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container >
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step" >{step}</div>
                <div className="headingName" style={{color:"#005c87"}}>{this.props.t("Event Introduction")}</div>
              </div> */}
              <div className="formBody">
                <InputContainer>
                  <StyledLabel margin='0px' marginb='12px'>{this.props.t("Title of the Event")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={"Enter title"}
                    name="title"
                    onChange={this.onChangeInput}
                    value={title}
                    maxLength="30"
                    disabled={this.state.isThemeEvent}
                    // 
                    // border={"1px solid #afcbd3"}
                  />
                  <div className="count">{title?.length}/30 | C</div>
                </InputContainer>

                <Border style={{background:'#EFEFEF',margin:'20px 0px'}}/>

                <StyledLabel style={{marginTop:"0px"}}>{this.props.t("Event image")}{<span className="imp">*</span>}<span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  closeIcon={closeIcon}
                  UploadIcon={UploadIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                /> 
                {/* <UploadPhotoContainer>
                  <div className="innerDivImageContainer">
                    {this.state.imgSrc ? (
                      <RemoveImageV2 >
                        <img alt="profilre-img" src={this.state.imgSrc}></img>
                        <div className="main-div" onClick={this.removePhoto}>
                          <div className="icon-div" ><div className="sub-icon-div">{closeIcon("white","8","8")}</div></div>
                        </div>
                      </RemoveImageV2>
                    ) : (
                      <div className="uploadImage">
                        <InputImage
                          className="edit-profile-pic "
                          imageReload={1}
                          style={{background:"none"}}
                        >
                          <div className="middle-section">
                            <div>{UploadIcon()}</div>
                            <div className="title">{this.props.t("Upload File")}</div>
                            <div className="sub-title">{this.props.t(".jpeg, .png")}</div>
                            
                          </div>
                          <input
                            id="event-upload-file"
                            type="file"
                            name="user"
                            accept=".jpeg, .png, .jpg"
                            multiple={false}
                            onChange={(e) => this.onChange(e)}
                            onClick={(e) =>
                              e.target.files[0] && this.onChange(e)
                            }
                          />
                        </InputImage>
                      </div>
                    )}
                  </div>
                </UploadPhotoContainer> */}
                <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
                <InputContainer>
                  <StyledLabel style={{marginTop:"0px"}}>{this.props.t("About the event")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor
                      content={description}
                      onChange={this.onChangeDescription}
                      disabled={this.state.isThemeEvent}
                    />
                  </EditorContainer>
                  <div className="char-count">{charCount ||0}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  DropdownIndicator = () => (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: 'absolute', top: '15px' }}
    >
      <path
        d="M12 10C12 10.3585 11.8559 10.7169 11.5684 10.9901L2.51663 19.5897C1.94083 20.1368 1.00725 20.1368 0.431681 19.5897C-0.143894 19.0429 -0.143894 18.1561 0.431681 17.609L8.44122 10L0.43196 2.39098C-0.143614 1.84394 -0.143614 0.957264 0.43196 0.410484C1.00753 -0.136826 1.94111 -0.136826 2.51691 0.410484L11.5687 9.00992C11.8563 9.28333 12 9.64172 12 10Z"
        fill="#007AB1"
      />
    </svg>
    
  );

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  };

  onDropDownSelectCoach = (name, id, value) => {
    this.setState({
      [name]: id,
      coachName: value
    });
  };

  onSelectCoach = (name, /*value, key*/) => {
    this.setState({
      coachName: name.name,
      coachId: name.id,
    });
  };

  stepTwoThemeEventForm = ()=>{

    const{step,eventThemePointValue,participantingPointValue,eventPoints} =this.state;

    return(
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              <div className="formBody">
                <div className="FormHeading">User participation</div>
                <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />

                <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"0px 0px 12px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Event point value")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select point")}
                  title={
                    eventThemePointValue !== null && eventThemePointValue !== undefined
                      ? `${eventThemePointValue} pts`
                      : ""}
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={eventPoints}
                  onSelect={this.onSelectPointsThemeEvent}
                  active={eventThemePointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  dropIcon={true}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                />
                <Border style={{display:"flex", background: '#EFEFEF', margin: '12px 0px' }}/>
                <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Points for Participating in Moments")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select point")}
                  title={
                    participantingPointValue !== null && participantingPointValue !== undefined
                      ? `${participantingPointValue} pts`
                      : ""}
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={wellnessChallengePoints}
                  onSelect={this.onSelectPointsParticipation}
                  active={participantingPointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  dropIcon={true}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                />
              </div>

            </div>
          </Container>
        </div>
      </Layout>
    )
  }








  stepTwoForm = () => {
    const {
      step,
      // apiChecker,
      location,
      eventLink,
      addLimitCheckbox,
      limitUser,
      selectedOption,
      eventPointValue,
      eventPoints,
      selectFlayer,
      flayerName,
      // coachId,
      coachName,
      getCoachData
      // progress,
    } = this.state;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName">
                  {this.props.t("How would you like to customize your event?")}
                </div>
              </div> */}
              <div className="formBody">
                <StyledLabel margin='0px' marginb='0px'>{this.props.t("Type of event")}?{<span>*</span>}</StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="12px" width gap>
                    <div className="RadioButtonContainer " 
                      // onClick={() => this.toggleRadioButton(0)}
                    >
                      <RadioButton
                        id="onsite"
                        // handler={this.toggleRadioButton}
                        type="radio"
                        checked={selectedOption === 0}
                        label={t("Onsite Event")}
                        challengeCreate={true}
                        disabled
                      />
                      <div className="label">{t("Onsite Event")}</div> 
                    </div>
 
                    <div className="RadioButtonContainer " 
                      // onClick={() => this.toggleRadioButton(1)}
                    >
                      <RadioButton
                        id="virtual"
                        // handler={this.toggleRadioButton}
                        type="radio"
                        checked={selectedOption === 1}
                        disabled
                      />
                      <div className="label">{t("Virtual Event")}</div> 
                    </div>
                  </RadioButtonWrapper>
                </div>
                <Border style={{background:'#EFEFEF',marginTop:"8px"}}/>
                <StyledLabel color={"#184A61"} margin={"8px"} marginb={"12px"}>
                  {this.props.t(selectedOption === 0 ? "Event location" : 'URL')} {<span>*</span>}
                </StyledLabel>
                {selectedOption === 0 ? (
                  <StyledInputV2
                    placeholder={t("Enter conference room number, location, etc")}
                    name="location"
                    value={location}
                    onChange={this.onLocationChange}
                    locationInput
                    // disabled
                  />
                ) : (
                  <StyledInputV2
                    placeholder={t("app.woliba.io/events/on-demand/medical/147")}
                    name="eventLink"
                    onChange={this.onChangeInput}
                    value={eventLink}
                    // disabled
                  />
                )}
                <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
                <InputContainer>
                  <StyledLabel color={"#184A61"} margin={"0px"} marginb={"0px"}>
                    {this.props.t("Event limit users")} {<span>*</span>}
                  </StyledLabel>

                  <div className="radioButtonDiv">
                    <RadioButtonWrapper isMargin="12px" width gap>
                      <div className="RadioButtonContainer " 
                        // onClick={() => this.changeLimitCheckBox(false)}
                      >
                        <RadioButton
                          id="onsite"
                          // handler={this.changeLimitCheckBox}
                          // value={0}
                          type="radio"
                          checked={!addLimitCheckbox}
                          label={t("No Limit")}
                          challengeCreate={true}
                          disabled
                        />
                        <div className="label">{t("No Limit")}</div> 
                      </div>
 
                      <div className="RadioButtonContainer " 
                        // onClick={() => this.changeLimitCheckBox(true)}
                      >
                        <RadioButton
                          id="virtual"
                          // handler={this.changeLimitCheckBox}
                          // value={0}
                          type="radio"
                          checked={addLimitCheckbox}
                          disabled
                        />
                        <div className="label">{t("Add Limit")}</div> 
                      </div>
                    </RadioButtonWrapper>
                  </div>

                  {addLimitCheckbox &&<>
                    <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
                    <StyledLabel color={"#184A61"} margin={"0px"} marginb={"12px"}>
                      {this.props.t("Event limit")} {<span>*</span>}
                    </StyledLabel>
                    <StyledInputV2
                      placeholder={t("Add event user limit")}
                      type={addLimitCheckbox ? "number" : "text"}
                      name="limitUser"
                      onChange={this.onChangeInput}
                      value={addLimitCheckbox ? limitUser : t("No Limit")}
                      min="1"
                      pattern="[0-9]*"
                      disabled
                      color={"#184A61"}
                      bgColor={"white"}
                      pColor={"#BDBDBD"}
                      border={"1px solid #BDBDBD"}
                    /></>}
                </InputContainer>
                {/* <InputContainer>
                  <StyledLabelV2>
                    <div className="name" style={{color:"#005c87"}}>
                      {this.props.t("Event limit users")}{<span>*</span>}
                    </div>
                    <div className="radio" style={{color:"#005c87"}}>
                      <CustomRadioButton
                        // onClick={() => this.changeLimitCheckBox(false)}
                        style={{color:"#005c87",border:"1px solid #669db7"}}
                        background={"#85c0ea"}
                        disabled={true}
                      >
                        {" "}
                        {!addLimitCheckbox && <div></div>}
                      </CustomRadioButton>
                      {this.props.t("No Limit")}
                      <CustomRadioButton
                        // onClick={() => this.changeLimitCheckBox(true)}
                        style={{color:"#005c87",border:"1px solid #669db7"}}
                        background={"#85c0ea"}
                        marginL="24px"
                        disabled={true}
                      >
                        {" "}
                        {addLimitCheckbox && <div></div>}
                      </CustomRadioButton>
                      {this.props.t("Add Limit")}
                    </div>
                  </StyledLabelV2>
                  <StyledInputV2
                    placeholder={this.props.t("Enter limit here...")}
                    type={addLimitCheckbox ? "number" : "text"}
                    name="limitUser"
                    onChange={this.onChangeInput}
                    value={addLimitCheckbox ? limitUser : "No Limit"}
                    min="1"
                    pattern="[0-9]*"
                    disabled={true}
                    // disabled={!addLimitCheckbox}
                    border={"1px solid #afcbd3"}
                  />
                </InputContainer> */}

                <Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>

                <CommonDropdown
                  tileContainerStyle={{ width: "100%", padding:"0px 0px 20px 0px" }}
                  dropdownStyle={{ top: "95px" }}
                  labelText={"Events Point Value"}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select Option")}
                  title={
                    (eventPointValue || eventPointValue === 0) && eventPointValue + " pts"
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={eventPoints}
                  onSelect={this.onSelectPoints}
                  active={eventPointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  dropIcon={true}
                />
                <Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>
                <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Event Host")}
                  isRequired={true}
                  dropdownOpen={this.state.so3}
                  placeholder={this.props.t("Select Option")}
                  title={
                    coachName
                      ? `${coachName}`
                      : this.props.t("Select Coach")
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so3: !this.state.so3 })}
                  data={getCoachData}
                  onSelect={this.onSelectCoach}
                  active={coachName}
                  onSelectParameter={["coachName", "name"]}
                  // valueString={"name"}
                  itemValue={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  dropIcon={true}
                />
                {/* {
                  <TitleContainer padding="0px 0px 0px 0px">
                    <StyledLabel margin={"0px"} marginb='0px'>{this.props.t("Event Host")}</StyledLabel>
                    <NewActivityDropdownCommon
                      onClick={() => this.setState({ so3: !this.state.so3 })}
                    >
                      <Dropdown.Toggle>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div style={{color: !coachName&& "rgba(0, 92, 135, 0.30)" }}>{getCoachData?.length==0?"None": coachName?coachName:"Select Coach"}</div>
                          <div>
                            {getCoachData?.length>0 &&<img
                              alt="image"
                              src={"/public/images/teamDownArrow.svg"}
                            />}
                          </div>
                        </div>
                      </Dropdown.Toggle>
                      {getCoachData?.length>0 &&<Dropdown.Menu>
                        {getCoachData?.length>0 && getCoachData.map((item, index) => (
                          <Dropdown.Item
                            eventKey={index}
                            key={index}
                            onClick={() =>
                              this.onDropDownSelectCoach("coachId", item.id, item.name)
                            }
                            active={coachId === item.id}
                          >
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>}
                    </NewActivityDropdownCommon>
                  </TitleContainer>} */}
                <Border style={{padding:'8px 0px',display:"flex",marginTop:'0px'}}/>
                <StyledLabel margin='0px' marginb='0px'>
                  {this.props.t("Would you like to add promotional document?")}{<span>*</span>}
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="12px" width gap>
                    <div className="RadioButtonContainer " onClick={() => this.toggleFlayer(0)}>
                      <RadioButton
                        id="flyer-yes"
                        handler={this.toggleFlayer}
                        // value={0}
                        type="radio"
                        checked={selectFlayer === 0}
                      />
                      <div className="label">{t("Yes")}</div> 
                    </div>
  
                    <div className="RadioButtonContainer " onClick={() => this.toggleFlayer(1)}>
                      <RadioButton
                        id="flyer-yes"
                        handler={this.toggleFlayer}
                        // value={0}
                        type="radio"
                        checked={selectFlayer === 1}
                      />
                      <div className="label">{t("No")}</div> 
                    </div>
                  </RadioButtonWrapper>
                  {/* <span onClick={() => this.toggleFlayer(0)}>
                    <RadioButton
                      id="1"
                      handler={this.toggleFlayer}
                      value={0}
                      isChecked={selectFlayer === 0}
                      label={this.props.t("Yes")}
                      challengeCreate={true}
                      style={{color:"#005c87"}}
                    />
                  </span>
                  <span onClick={() => this.toggleFlayer(1)}>
                    <RadioButton
                      id="2"
                      handler={this.toggleFlayer}
                      value={1}
                      isChecked={selectFlayer === 1}
                      label={this.props.t("No")}
                      challengeCreate={true}
                      style={{color:"#005c87"}}
                    />
                  </span> */}
                </div>

                {selectFlayer === 0 && (
                  <>
                    <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px',display:"flex"}}/>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb={'8px'}>{this.props.t("Add promotional document")}{<span className="imp">*</span>}</StyledLabel>
                    <CommonImageUploader
                      imgSrc={this.state.flayerValue}
                      t={t}
                      closeIcon={closeIcon}
                      UploadIcon={UploadHDMIcon}
                      onImageChange={this.uploadPDFFile}
                      onRemoveImage={()=>flayerName ? this.removePDF() : ""}
                      type={'promotional'}
                      imageName={this.state.flayerName}
                      accept={".jpeg, .png, .jpg, .pdf"}
                    /></>)}

                {/* {selectFlayer === 0 && ( <UploadPhotoContainer>
                  <div className="innerDivImageContainer">
                    <div className="uploadImage">
 
                      <InputImage
                        className="edit-profile-pic "
                        imageReload={1} 
                        style={{background:"unset",color:"#005c87",width:"100%", display:"flex",alignItems:"center",justifyContent:"center"}}
                      >
                        <div className="middle-section" style={{textAlign:"center"}}>
                          {flayerName
                            ? (<React.Fragment>   
                              <CircleNew width="70px" height="70px">
                                <CircularProgressBar
                                  strokeWidth="7"
                                  sqSize="64"
                                  percentage={100}
                                  color="#76AB78"
                                  hideText={true}
                                  // textValue="Culture Score"
                                />
                              </CircleNew>                           
                              <span className="flyer-name">{flayerName}</span></React.Fragment>)
                            : (<React.Fragment>                              
                              <div>{UploadIcon()}</div>
                              <div className="title">{this.props.t("Upload File")}</div>
                              <div className="sub-title">{this.props.t(".pdf, .jpeg, .png")}</div></React.Fragment>)}
 
                              
                        </div>
                        <input
                          id="event-upload-file"
                          type="file"
                          name="user"
                          accept=".jpeg, .png, .jpg, .pdf"
                          multiple={false}
                          onChange={(e) => this.uploadPDFFile(e)}
                          onClick={(e) =>
                            e.target.files[0] && this.uploadPDFFile(e)
                          }
                        />
                      </InputImage>
                      {flayerName && ( 
                        <RemoveImageV2 >
                          <div className="main-div" onClick={flayerName ? () => this.removePDF() : ""}>
                            <div className="icon-div" ><div className="sub-icon-div">{closeIcon("white","8","8")}</div></div>
                          </div>
                        </RemoveImageV2>)}
                    </div>
 
                  </div>
                </UploadPhotoContainer>)} */}

              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  noOperation = () => {};

  removeCommaFromFirstPlace = (str) => {
    if (str.charAt(0) === ",") {
      return str.substring(1);
    }
    return str;
  };

  companyToggleButton = (e) => {
    this.setState({
      selectedCompanyCheckBox: e,
      companies: [],
      selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({
        com_location: [],
      });
    }
  };

  selectSpouseDependent = (stateName) => {
    this.setState((prev) => ({
      [stateName]: !prev[stateName],
    }));
  };

  selectAllLocation = (e, locationDetails) => {
    e.preventDefault();
    const { com_location, selectedLocation } = this.state;
    if (com_location.length == locationDetails?.length) {
      this.setState({
        com_location: selectedLocation,
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails?.length; i++) {
        arr.push(locationDetails[i].id);
      }
      this.setState({
        com_location: arr,
      });
    }
  };

  selectAllTeam = (e, teamDetails)=>{
    e.preventDefault();
    const { teams, presentTeams } = this.state;
    if (teams.length == teamDetails.length) {
      this.setState({
        teams: presentTeams,
      });
    } else {
      let arr = [];
      for (let i = 0; i < teamDetails.length; i++) {
        arr.push(teamDetails[i].id);
      }
      this.setState({
        teams: arr,
      });
    }

  }


  selectAllDepartment = (e, locationDetails) => {
    e.preventDefault();
    const { departments, presentDepartments } = this.state;
    if (departments.length == locationDetails?.length) {
      this.setState({
        departments: presentDepartments,
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails?.length; i++) {
        arr.push(locationDetails[i].id);
      }
      this.setState({
        departments: arr,
      });
    }
  };

  stepThreeForm = () => {
    const {
      companies,
      com_location,
      companiesPermission,
      step,
      // selectLocation,
      selectedCompanyValue,
      selectedCompanyCheckBox,
      selectedLocation,
      selectedCompany,
      isEmployee,
      isDependent,
      isSpouse,
      filteredCompanies,
      usersToInvite,
      allTeams,
      teams,
      departments,
      presentTeams,
      presentDepartments,
      companyInfo,
      isThemeEvent
    } = this.state;
    const { /*allCompanies,*/ locationDetails, role, eventDetail, /*companyDetails,*/t, departmentDetails, isAccountManager,allRoles } = this.props;
    const isSuperAdmin = allRoles?.some((role) => role.rid === 3);
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName">{this.props.t("Who would you like to invite?")}</div>
              </div> */}
              <div className="formBody">
                {(companiesPermission||isAccountManager) && (
                  <StyledLabel margin='0px' marginb='0px'>
                    {this.props.t("Host your event for?")}{<span>*</span>}
                  </StyledLabel>
                )}
                {(companiesPermission||isAccountManager) && (
                  <>
                    <div className="radioButtonDiv">
                      <RadioButtonWrapper width gap>
                        {isThemeEvent ? null : <div className="RadioButtonContainer">
                          <RadioButton
                            type="radio"
                            name="option-global"
                            checked={selectedCompanyCheckBox === 0}
                            id="global"
                            value={0}
                            handler={this.companyToggleButton}
                            disabled
                          />
                          <div className="label">Global</div>
                        </div>}
   
                        <div className="RadioButtonContainer">
                          <RadioButton
                            type="radio"
                            name="option-individual"
                            checked={selectedCompanyCheckBox === 1}
                            id="individual"
                            value={0}
                            handler={this.companyToggleButton}
                            disabled
                          />
                          <div className="label">For an Individual Company</div>
                        </div> 
                      </RadioButtonWrapper>
   
                      {/* <span>
                      <RadioButton
                        id="1"
                        // handler={this.companyToggleButton}
                        value={0}
                        isChecked={selectedCompanyCheckBox === 0}
                        label={this.props.t("Global")}
                        challengeCreate={true}
                        style={{color:"#005c87"}}
                        disabled
                      />
                    </span>
                    <span>
                      <RadioButton
                        id="2"
                        // handler={this.companyToggleButton}
                        value={1}
                        isChecked={selectedCompanyCheckBox === 1}
                        label={this.props.t("For an Individual Company")}
                        challengeCreate={true}
                        style={{color:"#005c87"}}
                        disabled
                      />
                    </span> */}
                    </div>
                    {isSuperAdmin ? <Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>:null}
                  </>
                )}
                {(role === "ADMIN"||isAccountManager) && (<Border style={{background:'#EFEFEF',margin:'20px 0px 8px 0px',display:"flex"}}/>)}
                {selectedCompanyCheckBox === 0 && (companiesPermission||isAccountManager) && (
                  <>

                    <StyledLabel margin="0px">
                      {this.props.t("Search company you want to add")}{" "}{ companies.length > 1 ? "(" + companies.length + " Companies Selected)" : "(" + companies.length + " Company Selected)"}{<span>*</span>}
                    </StyledLabel>
                   
                     
                    <SearchFilter1 style={{width:"416px",maxWidth:"416px",background:"none"}}>
                      <StyledInputV2
                        type="text" placeholder={t("Search")}
                        value={this.state.searchTerm} 
                        onChange={this.handleSearch} 
                        // onKeyDown={this.handleKeyDown}
                        style={{border:"none"}}
                        height={"36px"}
                      />
                    </SearchFilter1>
                   
                    {/* <Heading>
                    <div className="name" style={{color:"#005c87"}}>{this.props.t("Select Company To Invite")}</div>
                    <SearchFilter1 style={{width:"416px",maxWidth:"416px"}}>
                      <StyledInputV2
                        type="text" placeholder={t("Search company")}
                        value={this.state.searchTerm} 
                        onChange={this.handleSearch} 
                        // onKeyDown={this.handleKeyDown}
                        style={{border:"none"}}
                      />
                      <div className="search-icon"> {SearchButtonIcon()}</div>
                    </SearchFilter1>
                  </Heading> */}
                  </>
                )}
                {selectedCompanyCheckBox === 0 && (companiesPermission||isAccountManager) ? (
                  <Locationwrapper  background="white">
                    {filteredCompanies && filteredCompanies.length > 0
                      ? filteredCompanies.map((company, index) => (
                        <div className="checkBoxWidth" key={index}>
                          {/* <span style={{color:"#005c87"}}>
                            <CustomRadioButton
                              onClick={selectedCompany.includes(company.id) &&companies.includes(company.id)
                                ? null: () =>this.onCheckboxChange(company.id,company.company_name)}
                              background="#afcbd3"
                              
                            >
                              {" "}
                              {selectedCompany.includes(company.id) &&
                              companies.includes(company.id) ? (
                                  <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                                ) : companies.includes(company.id) ? (
                                  <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                                ) : null}{" "}
                            </CustomRadioButton>
                            {company.company_name}
                          </span> */}
                          <span style={{color:"#092F41",gap:"16px"}}>
                            <ManagerIconContainer selected={companies.includes(company.id)} isWidth="20px" isHeight="20px" disabled={company.show_events === 0 || selectedCompany.includes(company.id)}>
                              <div
                                className="archive-action"
                                onClick={() =>{
                                  if( company.show_events === 1 ){
                                    selectedCompanyCheckBox === 0 ? selectedCompany.includes(company.id) &&companies.includes(company.id) ? null : this.onCheckboxChange(company.id,company.company_name) : selectedCompanyCheckBox === 1 ? this.onSelectLocation(company) : null
                                  }

                                }
                                }
                              >
                                {companies.includes(company.id) ? RecognitionTickIcon(company.show_events === 0 || selectedCompany.includes(company.id) ? "#BDBDBD" :""): null}
                              </div>
                            </ManagerIconContainer>
                            <div className="label" style={{color: company.show_events === 0 || selectedCompany.includes(company.id) ? '#BDBDBD' : '#092F41',cursor: company.show_events === 0 || selectedCompany.includes(company.id) ? 'not-allowed' : 'pointer',}}  title={company.company_name}>{company.company_name}</div>
                          </span>
                        </div>
                      ))
                      : null}
                  </Locationwrapper>
                ) : (
                  (companiesPermission||isAccountManager) && (
                    <React.Fragment>

                      {/* <Heading>
                        <div className="name" style={{color:"#005c87"}}>{this.props.t(`Select a company to invite`)} <span> &nbsp;{companies ? "(01 Company Selected)" : ""} </span></div>
                        <SearchFilter1 style={{width:"416px",maxWidth:"416px"}}>
                          <StyledInputV2
                            type="text" placeholder={t("Search company")}
                            value={this.state.searchTerm} 
                            onChange={this.handleSearch} 
                            // onKeyDown={this.handleKeyDown}
                            style={{border:"none"}}
                          />
                          <div className="search-icon"> {SearchButtonIcon()}</div>
                        </SearchFilter1>
                      </Heading> */}

                      {/* <StyledLabel margin="0px">
                        {this.props.t("Search company you want to add")}{" "}{ companies.length > 1 ? "(" + companies.length + " Companies Selected)" : "(" + companies.length + " Company Selected)"}{<span>*</span>}
                      </StyledLabel> */}


                      <StyledLabel margin="0px">
                        {this.props.t("Search company you want to add")}{" "}
                        {selectedCompanyCheckBox !== 1 ? companies.length > 0 && (
                          `(${companies.length} ${companies.length === 1 ? "Company" : "Companies"} Selected)`
                        ) :null}
                        <span>*</span>
                      </StyledLabel>
                       
                       
                      <SearchFilter1 style={{width:"416px",maxWidth:"416px",background:"none"}}>
                        <StyledInputV2
                          type="text" placeholder={t("Search")}
                          value={this.state.searchTerm} 
                          onChange={this.handleSearch} 
                          // onKeyDown={this.handleKeyDown}
                          style={{border:"none"}}
                          height={"36px"}
                        />
                      </SearchFilter1>
   
                      <Locationwrapper background="white">
                        {filteredCompanies && filteredCompanies.length > 0
                          ? filteredCompanies.map((company, index) => (
                            <div className="checkBoxWidth" key={index}>
                              <span style={{color:"#092F41",gap:"16px"}}>
                                {/* <div className="RadioButtonContainer " onClick={() => this.onSelectLocation(company)}> */}
                                <RadioButton
                                  type="radio"
                                  name={company.id}
                                  checked={companies[0]=== company.id}
                                  id={company.id}
                                  value={companies[0]}
                                  handler={()=>this.onSelectLocation(company)}
                                  disabled
                                />
                                <div className="label" 
                                  style={{color: company.show_events === 0 ? '#BDBDBD' : '#092F41',cursor: company.show_events === 0 ? 'not-allowed' : 'pointer',}} 
                                  title={company.company_name}>{company.company_name}</div>
                              </span>
                              {/* <span style={{color:"#005c87"}} 
                                // onClick={()=>this.onSelectLocation(company)}
                              >
                                <RadioButton
                                  handler={()=>this.onSelectLocation(company)}
                                  id={company.id}
                                  value={companies}
                                  isChecked={companies.includes(company.id)}
                                  label={t(company.company_name)}
                                  style={{color:"#005c87"}}
                                  challengeCreate={true}
                                  disabled
                                />
                              </span> */}
                            </div>
                          )): null}
                      </Locationwrapper>
   
                    </React.Fragment>
                  )
                )}
                {(role === "ADMIN"||isAccountManager) && (<Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/>)}
                 
                {/* <div className="name" style={{color:"#005c87",marginTop:"20px",marginBottom:"16px"}} >
                  {this.props.t("Select Users")}
                  <span className="astric">*</span>
                </div> */}
                { isSuperAdmin ? <Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>: null}
                <StyledLabel margin="8px" marginb="0px">
                  {this.props.t("Who would you like to invite?")}{<span>*</span>}
                </StyledLabel>

                <div className="radioButtonDiv" style={{zIndex:"10",position:"relative"}}>
                  <RadioButtonWrapper width gap>
                    <div className="RadioButtonContainer " 
                      // onClick={() => this.inviteToggleButton(0)}
                    >
                      <RadioButton
                        type="radio"
                        name="option1"
                        checked={usersToInvite === 0}
                        id="all-users"
                        value={0}
                        handler={this.inviteToggleButton}
                        disabled
                      />
                      <div className="label">All Users</div>
                    </div> 

                    {/* <span onClick={() => usersToInvite === 0 && this.inviteToggleButton(0)}>
                    <RadioButton
                      id="all-users"
                      handler={this.inviteToggleButton}
                      value={0}
                      isChecked={usersToInvite === 0}
                      label={t("All Users")}
                      challengeCreate={true}
                      style={{color:"#005c87"}}
                      disabled={usersToInvite != 0}
                    />
                  </span> */}
                    {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && departmentDetails?.length > 0 &&( 
                      <>
                        <div className="RadioButtonContainer " 
                          // onClick={() => this.inviteToggleButton(1)}
                        >
                          <RadioButton
                            type="radio"
                            name="departments"
                            checked={usersToInvite === 1}
                            id="departments"
                            value={0}
                            handler={this.inviteToggleButton}
                            disabled
                          />
                          <div className="label">Departments</div>
                        </div> 
                    
                        {/* <span onClick={() => usersToInvite === 1 && this.inviteToggleButton(1)}>
                          <RadioButton
                            id="departments"
                            handler={this.inviteToggleButton}
                            value={1}
                            isChecked={usersToInvite === 1}
                            label={t("Departments")}
                            challengeCreate={true}
                            style={{color:"#005c87"}}
                            disabled={usersToInvite !== 1}
                          />
                        </span> */}
                      </>)}
                    {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && locationDetails?.length > 0 &&(

                      <>
                        <div className="RadioButtonContainer " 
                          // onClick={() => this.inviteToggleButton(2)}
                        >
                          <RadioButton
                            type="radio"
                            name="locations"
                            checked={usersToInvite === 2}
                            id="locations"
                            value={0}
                            handler={this.inviteToggleButton}
                            disabled
                          />
                          <div className="label">Locations</div>
                        </div> 
                      
                        {/* <span onClick={() => usersToInvite === 2 && this.inviteToggleButton(2)}>
                          <RadioButton
                            id="locations"
                            handler={this.inviteToggleButton}
                            value={2}
                            isChecked={usersToInvite === 2}
                            label={t("Locations")}
                            challengeCreate={true}
                            style={{color:"#005c87"}}
                            disabled={usersToInvite !== 2}
                          />
                        </span> */}
                      </>)}
                    {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && allTeams.length > 0 &&(
                      <>
                        <div className="RadioButtonContainer " 
                          // onClick={() => this.inviteToggleButton(3)}
                        >
                          <RadioButton
                            type="radio"
                            name="teams"
                            checked={usersToInvite === 3}
                            id="teams"
                            value={0}
                            handler={this.inviteToggleButton}
                            disabled
                          />
                          <div className="label">Teams</div>
                        </div> 
                        {/* <span onClick={() => usersToInvite === 3 &&  this.inviteToggleButton(3)}>
                          <RadioButton
                            id="teams"
                            handler={this.inviteToggleButton}
                            value={3}
                            isChecked={usersToInvite === 3}
                            label={t("Teams")}
                            challengeCreate={true}
                            style={{color:"#005c87"}}
                            disabled={usersToInvite !== 3}
                          />
                        </span> */}
                      </>)}

                  </RadioButtonWrapper>
                </div>

                {/* <Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/> */}
                {((role === "ADMIN"||isAccountManager) &&
                  locationDetails &&
                  locationDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 && usersToInvite === 2) ||
                (locationDetails &&
                  locationDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager) && usersToInvite === 2) ? (
                    <StyledLabel margin='8px'>
                      {this.props.t("Select Locations")}{<span>*</span>}
                    </StyledLabel>
                  ) : null}

                {((role === "ADMIN"||isAccountManager) &&
                  locationDetails &&
                  locationDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1  && usersToInvite === 2) ||
                (locationDetails &&
                  locationDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 2) ? (<Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}}>
                    <div className="checkBoxWidth" >
                      <span style={{color:"#092F41",gap:"16px"}}>
                        <ManagerIconContainer selected={com_location.length === locationDetails?.length} isWidth="20px" isHeight="20px" disabled={selectedLocation.length === locationDetails?.length}>
                          <div
                            className="archive-action"
                            onClick={(e) =>
                              selectedLocation.length != locationDetails?.length && this.selectAllLocation(e, locationDetails)
                            }
                          >
                            {com_location.length === locationDetails?.length
                              ? RecognitionTickIcon()
                              : null}
                          </div>
                        </ManagerIconContainer>
                        {com_location.length === locationDetails?.length
                          ? this.props.t("Deselect All")
                          : this.props.t("Select All")}
                      </span>
                      {/* <span style={{color:"#005c87"}}>
                        <CustomRadioButton
                          onClick={(e) =>
                            selectedLocation.length != locationDetails?.length && this.selectAllLocation(e, locationDetails)
                          }
                          style={{color:"#005c87",border:"1px solid #669db7"}}
                          background={"#85c0ea"}
                          disabled={selectedLocation.length === locationDetails?.length}
                        >
                          {" "}
                          {locationDetails &&
                            com_location.length === locationDetails?.length && (<div></div>)}{" "}
                        </CustomRadioButton>{" "}
                        {this.props.t("All Locations")}
                        {locationDetails &&
                        com_location.length === locationDetails.length
                          ? this.props.t("Deselect All")
                          : this.props.t("Select All")} 
                      </span> */}
                    </div>
                    {locationDetails && locationDetails?.length > 0
                      ? locationDetails.map((loc, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <span style={{color:"#092F41",gap:"16px"}}>
                            <ManagerIconContainer selected={com_location.includes(loc.id)} isWidth="20px" isHeight="20px" disabled={selectedLocation.includes(loc.id)}>
                              <div
                                className="archive-action"
                                onClick={selectedLocation &&selectedLocation.includes(loc.id) &&com_location &&com_location.includes(loc.id)
                                  ? null: () => this.onChangeLocation(loc.id)}
                              >
                                {com_location.includes(loc.id)
                                  ? RecognitionTickIcon(selectedLocation.includes(loc.id) ? "#BDBDBD" : "") 
                                  : null}
                              </div>
                            </ManagerIconContainer>
                            {this.removeCommaFromFirstPlace(loc.location)}
                          </span>
                          {/* <span style={{color:"#005c87"}}>
                            <CustomRadioButton
                              onClick={selectedLocation &&selectedLocation.includes(loc.id) &&com_location &&com_location.includes(loc.id)
                                ? null: () => this.onChangeLocation(loc.id)}
                              background="#afcbd3"
                              disabled={selectedLocation.includes(loc.id)}
                              
                            >
                              {" "}
                              {selectedLocation &&selectedLocation.includes(loc.id) && com_location && com_location.includes(loc.id) ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>) : com_location &&
                                  com_location.includes(loc.id) ? (
                                  <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                                ) : null}{" "}
                            </CustomRadioButton>
                            {this.removeCommaFromFirstPlace(loc.location)}
                          </span> */}
                        </div>)): null}
                  </Locationwrapper>) : null}

                {/* Dpartment Listing */}

                {((role === "ADMIN"||isAccountManager) &&
                  departmentDetails && 
                  departmentDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0 && usersToInvite === 1) ||
                (departmentDetails &&
                  departmentDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 1 ) ? (                      
                    <StyledLabel margin='8px'>
                      {t("Select Departments")}{<span>*</span>}
                    </StyledLabel>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 1 && departmentDetails &&
                  departmentDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0) ||
                (departmentDetails &&
                  departmentDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 1 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}}>
                      <div className="checkBoxWidth" >
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={departments?.length === departmentDetails?.length} isWidth="20px" isHeight="20px"
                            disabled={ presentDepartments.length === departmentDetails?.length}
                          >
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                presentDepartments.length != departmentDetails?.length && this.selectAllDepartment(e, departmentDetails)
                              }
                            >
                              {departments?.length === departmentDetails?.length
                                ?  RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {departmentDetails &&
                            departments?.length === departmentDetails?.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                        {/* <span style={{color:"#005c87"}}>
                          <CustomRadioButton
                            onClick={(e) =>
                              presentDepartments.length != departmentDetails?.length && this.selectAllDepartment(e, departmentDetails)
                            }
                            style={{color:"#005c87",border:"1px solid #669db7"}}
                            background={"#85c0ea"}
                            disabled={ presentDepartments.length === departmentDetails?.length}
                          >
                            {" "}
                            {departmentDetails &&
                              departments.length === departmentDetails?.length && (<div></div>)}{" "}
                          </CustomRadioButton>{" "}
                          {departmentDetails &&
                          departments.length === departmentDetails?.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span> */}
                      </div>
                      {departmentDetails && departmentDetails?.length > 0
                        ? departmentDetails.map((dep, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span style={{color:"#092F41",gap:"16px"}}>
                              <ManagerIconContainer selected={departments.includes(dep.id)} isWidth="20px" isHeight="20px" disabled={presentDepartments.includes(dep.id)}>
                                <div
                                  className="archive-action"
                                  onClick={() => !presentDepartments.includes(dep.id) && this.onChangeDepartment(dep.id)}
                                >
                                  {departments.includes(dep.id)
                                    ? RecognitionTickIcon(presentDepartments.includes(dep.id) ? "#BDBDBD" : "")
                                    : null}
                                </div>
                              </ManagerIconContainer>
                              {this.removeCommaFromFirstPlace(dep.department)}
                            </span>
                            {/* <span style={{color:"#005c87"}}>
                              <CustomRadioButton
                                onClick={() => !presentDepartments.includes(dep.id) && this.onChangeDepartment(dep.id)}
                                background="#afcbd3"
                                style={{border:"1px solid #649bb3"}}
                                disabled={presentDepartments.includes(dep.id)}
                              >
                                {" "}
                                {departments.includes(dep.id) && (
                                  // <div></div>
                                  <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                                )}{" "}
                              </CustomRadioButton>
                              {this.removeCommaFromFirstPlace(dep.department)}
                            </span> */}
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* Teams Listing */}

                {((role === "ADMIN"||isAccountManager) &&
                  allTeams && 
                  allTeams.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0 && usersToInvite === 3) ||
                (allTeams &&
                  allTeams.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 3 ) ? (
                    <StyledLabel margin='8px'>
                      {this.props.t("Select Teams")}{<span>*</span>}
                    </StyledLabel>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 3 && allTeams &&
                  allTeams.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0) ||
                (allTeams &&
                  allTeams.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 3 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}}>
                      <div className="checkBoxWidth" >
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={teams?.length === allTeams?.length} isWidth="20px" isHeight="20px" disabled={presentTeams.length === allTeams.length}>
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                presentTeams.length != allTeams.length && this.selectAllTeam(e, allTeams)
                              }
                            >
                              {teams?.length === allTeams?.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {allTeams &&
                            teams?.length === allTeams?.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                        {/* <span style={{color:"#005c87"}}>
                          <CustomRadioButton
                            onClick={(e) =>
                              presentTeams.length != allTeams.length && this.selectAllTeam(e, allTeams)
                            }
                            style={{color:"#005c87",border:"1px solid #669db7"}}
                            background={"#85c0ea"}
                            disabled={presentTeams.length === allTeams.length}
                          >
                            {" "}
                            {allTeams &&
                              teams.length === allTeams.length && (<div></div>)}{" "}
                          </CustomRadioButton>{" "}
                          {allTeams &&
                          teams.length === allTeams.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span> */}
                      </div>
                      {allTeams && allTeams.length > 0
                        ? allTeams.map((team, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span style={{color:"#092F41",gap:"16px"}}>
                              <ManagerIconContainer selected={teams.includes(team.id)} isWidth="20px" isHeight="20px" disabled={presentTeams.includes(team.id)}>
                                <div
                                  className="archive-action"
                                  onClick={() => !presentTeams.includes(team.id) && this.onChangeTeam(team.id)}
                                >
                                  {teams.includes(team.id)
                                    ? RecognitionTickIcon(presentTeams.includes(team.id) ? "#BDBDBD" : "")
                                    : null}
                                </div>
                              </ManagerIconContainer>
                              {this.removeCommaFromFirstPlace(team.name)}
                            </span>
                            {/* <span style={{color:"#005c87"}}>
                              <CustomRadioButton
                                onClick={() => !presentTeams.includes(team.id) && this.onChangeTeam(team.id)}
                                background="#afcbd3"
                                style={{border:"1px solid #649bb3"}}
                                disabled={presentTeams.includes(team.id)}
                              >
                                {" "}
                                {teams.includes(team.id) && (
                                  // <div></div>
                                  <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                                )}{" "}
                              </CustomRadioButton>
                              {this.removeCommaFromFirstPlace(team.name)}
                            </span> */}
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* {(role === "ADMIN"||isAccountManager) && (<Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/>)} */}
                {(companyInfo?.show_spouse|| companyInfo?.show_dependent)||(companies?.length>0&&selectedCompanyCheckBox==1) && role != "ADMIN"?<Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>:null}
                {(companyInfo?.show_spouse|| companyInfo?.show_dependent) && selectedCompanyCheckBox === 1 ?<div>
               
                  {(companyInfo?.show_spouse || companyInfo?.show_dependent ||  (locationDetails?.length === 0 && usersToInvite === 2)) && companies?.length > 0 && selectedCompanyCheckBox === 1  ? (                 
                    <StyledLabel margin='0px' marginb="12px">
                      {this.props.t("Are you also interested in extending an invitation?")}{<span>*</span>}
                    </StyledLabel>) : null}

                  {(role === "ADMIN"||isAccountManager) && selectedCompanyCheckBox === 1 ? (
                    <Locationwrapper  background="white">
                      {companyInfo?.show_spouse ? <div className="checkBoxWidth">
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer  selected={eventDetail.spouse || isSpouse} isWidth="20px" isHeight="20px" disabled={eventDetail.spouse} >
                            <div
                              className="archive-action"
                              onClick={() => !eventDetail.spouse && this.selectSpouseDependent("isSpouse")}
                              
                            >
                              {eventDetail.spouse || isSpouse
                                ? RecognitionTickIcon(eventDetail.spouse ? "#BDBDBD" : "")
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {this.props.t("Spouse")}
                        </span>
                        {/* <span style={{color:"#005c87"}}>
                          <CustomRadioButton
                            onClick={ ()=>{
                              !eventDetail.spouse &&  this.selectSpouseDependent("isSpouse")
                            }
                            }
                            background="#afcbd3"
                            disabled={eventDetail.spouse}
                            
                          >
                            {" "}
                            {eventDetail.spouse ? (
                              <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                            ) : isSpouse ? (
                              <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                            ) : null}{" "}
                          </CustomRadioButton>
                          {"Spouse"}
                        </span> */}
                      </div>:null}
                      {companyInfo?.show_dependent ? <div className="checkBoxWidth">
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={eventDetail.dependent || isDependent} disabled={eventDetail.dependent} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={() => this.selectSpouseDependent("isDependent")}
                            >
                              {eventDetail.dependent || isDependent
                                ? RecognitionTickIcon(eventDetail.dependent ? "#BDBDBD" :"")
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {this.props.t("Dependent")}
                        </span>
                        {/* <span>
                          <CustomRadioButton
                            onClick={()=>{
                              !eventDetail.dependent && this.selectSpouseDependent("isDependent")
                            }
                            }
                            disabled={eventDetail.dependent}
                          >
                            {" "}
                            {eventDetail.dependent ? (
                              <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                            ) : isDependent ? (
                              <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                            ) : null}{" "}
                          </CustomRadioButton>
                          {"Dependent"}
                        </span> */}
                      </div>:null}
                      {locationDetails && locationDetails?.length === 0 && (
                        <div className="checkBoxWidth">
                          <span>
                            <CustomRadioButton
                              onClick={
                                false || !eventDetail.is_spouse_or_dependent
                                  ? ""
                                  : () => this.selectSpouseDependent("isEmployee")
                              }
                            >
                              {" "}
                              {false || !eventDetail.is_spouse_or_dependent ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                              ) : isEmployee ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                              ) : null}{" "}
                            </CustomRadioButton>
                            {"Employee"}
                          </span>{" "}
                        </div>
                      )}
                    </Locationwrapper>
                  ) : (
                    (role != "ADMIN"&&!isAccountManager) && (
                      <Locationwrapper  background="white">
                        {companyInfo?.show_spouse ? <div className="checkBoxWidth">
                          <span style={{color:"#092F41",gap:"16px"}}>
                            <ManagerIconContainer  selected={isSpouse} isWidth="20px" isHeight="20px" disabled={eventDetail.spouse}>
                              <div
                                className="archive-action"
                                onClick={() => !eventDetail.spouse &&  this.selectSpouseDependent("isSpouse")}
                                
                              >
                                {eventDetail.spouse || isSpouse
                                  ? RecognitionTickIcon(eventDetail.spouse ? "#BDBDBD":"")
                                  : null}
                              </div>
                            </ManagerIconContainer>
                            {this.props.t("Spouse")}
                          </span>
                          {/* <span style={{color:"#005c87"}}>
                            <CustomRadioButton
                              onClick={ ()=>{
                                !eventDetail.spouse &&  this.selectSpouseDependent("isSpouse")
                              }
                              }
                              background="#afcbd3"
                              disabled={eventDetail.spouse}
                              
                            >
                              {" "}
                              {eventDetail.spouse ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                              ) : isSpouse ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                              ) : null}{" "}
                            </CustomRadioButton>
                            {this.props.t("Spouse")}
                          </span> */}
                        </div> : null}
                        {companyInfo?.show_dependent ? <div className="checkBoxWidth">
                          <span style={{color:"#092F41",gap:"16px"}}>
                            <ManagerIconContainer selected={isDependent} disabled={eventDetail.dependent} isWidth="20px" isHeight="20px">
                              <div
                                className="archive-action"
                                onClick={() => this.selectSpouseDependent("isDependent")}
                              >
                                {eventDetail.dependent || isDependent
                                  ? RecognitionTickIcon(eventDetail.dependent ? "#BDBDBD" :"" )
                                  : null}
                              </div>
                            </ManagerIconContainer>
                            {this.props.t("Dependent")}
                          </span>
                          {/* <span>
                            <CustomRadioButton
                              onClick={()=>{
                                !eventDetail.dependent && this.selectSpouseDependent("isDependent")
                              }
                              }
                              disabled={eventDetail.dependent}
                            >
                              {" "}
                              {eventDetail.dependent ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                              ) : isDependent ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                              ) : null}{" "}
                            </CustomRadioButton>
                            {this.props.t("Dependent")}
                          </span> */}
                        </div>: null}
                        {/* {locationDetails && locationDetails?.length === 0 && (
                        <div className="checkBoxWidth">
                          <span>
                            <CustomRadioButton
                              onClick={
                                false || !eventDetail.is_spouse_or_dependent
                                  ? ""
                                  : () =>
                                    this.selectSpouseDependent("isEmployee")
                              }
                            >
                              {" "}
                              {false || !eventDetail.is_spouse_or_dependent ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                              ) : isEmployee ? (
                                <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                              ) : null}{" "}
                            </CustomRadioButton>
                            {this.props.t("Employee")}
                          </span>{" "}
                        </div>
                      )} */}
                      </Locationwrapper>
                    )
                  )}</div>:null}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleFlayer = (e) => {
    this.setState({ selectFlayer: e });
  };

  hideShowCalendarPopup = (value) =>{
    this.setState({
      datePopup: value,
      showDatePopupModal: true
    })
  }

  hideCalendarPopup= () =>{
    this.setState({
      showDatePopupModal: false,
      datePopup: ""
    })
  }

  onChangeDateValue = (date, stateName) => {
    this.setState({
      [stateName]: dayjs(date),
      showDatePopupModal: false
    });
  };

  stepFourForm = () => {
    const {
      step,
      date,
      endDate,
      // time,
      // endTime,
      // openDateTimePicker,
      time_zone,
      recurringEvent,
      eventLimitValue,
      // apiChecker,
      // menuIsOpen,
      showDateTimeInput,
      // emailOption,
      // companyInfo,
      // companies,
      // selectedCompanyCheckBox,
      // usersToInvite,
      launch,
      // eventLink,
      showDatePopupModal,
      datePopup
    } = this.state;

    // let emailOptionKeys = Object.keys(emailOption);

    // const yesterday = Datetime.moment().subtract(23, "hour");
    // const valid = (currentDate) =>
    //   showDateTimeInput === "date"
    //     ? currentDate.isAfter(Datetime.moment())
    //     : currentDate.isAfter(yesterday);
    const eventWeeklyLimits = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const eventLimits = eventWeeklyLimits;
    // const disabledFunctions = apiChecker;
    const customStyles = {
      control: (base, state) => ({
        ...base,
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          borderColor: state.isFocused ? "hsl(0,0%,70%)" : "hsl(0,0%,70%)",
        },
      }),
    };
    let timeZoneValue;
    timezones["timezones"].map((zone) => {
      if (zone.value === time_zone) {
        timeZoneValue = zone.label;
      }
    });
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName">{this.props.t("When would you like to launch your event?")}</div>
              </div> */}
              <div className="formBody">
                <React.Fragment>
                  <StyledLabel  style={{marginTop:"0px"}}>
                    {this.props.t("When would you like to launch your event?")}
                    {<span>*</span>}
                  </StyledLabel>
                  <RadioButtonWrapper isMargin="12px" width gap>
                    <div className="RadioButtonContainer " 
                      // onClick={() =>  this.launchToggleButton(0)}
                    >
                      <RadioButton
                        id="global"
                        handler={this.launchToggleButton}
                        type="radio"
                        checked={launch === 0}
                        disabled
                      />
                      <div className="label">{t("Launch now")}</div> 
                    </div>

                    <div className="RadioButtonContainer " 
                      // onClick={() =>  this.launchToggleButton(1)}
                    >
                      <RadioButton
                        id="company"
                        handler={this.launchToggleButton}
                        type="radio"
                        checked={launch === 1}
                        disabled
                      />
                      <div className="label">{t("Schedule for later")}</div> 
                    </div>
                  </RadioButtonWrapper>
                  <Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>
                </React.Fragment>

                <TitleContainer fullWidth margin="0 0 12px 0" padding='0px'>
                  <StyledLabel  margin="0px" marginb="12px">
                    {this.props.t("What is your preferred time zone?")}
                    {<span>*</span>}
                  </StyledLabel>
                  <SearchDropDown
                    // transform={menuIsOpen ? "rotate(90deg)" : "0"}
                    pcolor={"#005c87"}
                    pfont="lato"
                    border={"1px solid #BDBDBD"}
                    background={"#EFEFEF"}
                    color="#BDBDBD"
                    disabled
                    isDisabledColor={"#BDBDBD !important"}
                  >
                    <Select
                      
                      defaultValue={timeZoneValue ? timeZoneValue : time_zone}
                      options={timezones["timezones"]}
                      onChange={(option) =>
                        this.onSelectCategory("time_zone", option.value)
                      }
                      classNamePrefix={"menu-item"}
                      styles={customStyles}
                      components={{ DropdownIndicator: this.DropdownIndicator }}
                      // onMenuOpen={this.toggleMenu}
                      // onMenuClose={this.toggleMenu}
                      placeholder={timeZoneValue ? timeZoneValue : time_zone}
                      isDisabled={true}
                    />
                  </SearchDropDown>
                </TitleContainer>
                <Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>

                <div className="dateCard" style={{marginTop:"10px",gap:"8px"}}>
                  <DateCalendarWrapper>
                    <div className="date-title">Start date and time</div>
                    <DateCard color={launch === 0 || !date} onClick={()=>launch != 0 && this.hideShowCalendarPopup("date")}>
                      {date? dayjs(date).format('MM/DD/YYYY | hh:mm A'): "Select start date and time"}
                      {launch === 1 && CalendarBranding()}
                    </DateCard>
                  </DateCalendarWrapper> 
                  <DateCalendarWrapper>
                    <div className="date-title" style={{display:"flex",justifyContent:"space-between"}}>{showDateTimeInput != "date" ? "End date and time" : null}
                      {/* <div className="radio" style={{ color: "#092F41",width:"auto",display:"flex" }}>
                        <CustomRadioButton
                          // onClick={() => !eventLink && this.changeDateTimeView(showDateTimeInput ? "" : "date")}
                          style={{ color: "#092F41", border: "1px solid #7C7C7C" }}
                          background={"#092F41"}
                          disabled
                        >
                          {" "}
                          {showDateTimeInput === "date" && <div></div>}
                        </CustomRadioButton>
                        {this.props.t("All Day")}
                      </div> */}

                      <div className="RadioButtonContainer " 
                        style={{display:'flex',gap:'8px'}}
                        // onClick={() => !eventLink && this.changeDateTimeView(showDateTimeInput ? "" : "date")}
                      >
                        <RadioButton
                          id="global"
                          handler={() => !eventLink && this.changeDateTimeView(showDateTimeInput ? "" : "date")}
                          type="radio"
                          checked={showDateTimeInput === "date"}
                          disabled
                        />
                        <div className="label">{t("All day")}</div> 
                      </div>
                    </div>
                    {showDateTimeInput != "date" ? <DateCard color={!endDate} onClick={()=>this.hideShowCalendarPopup("endDate")}>
                      {endDate? dayjs(endDate).format('MM/DD/YYYY | hh:mm A'): "Select end date and time"}
                      {CalendarBranding()}
                    </DateCard> : null}
                  </DateCalendarWrapper>

                </div>

                
                {/* <StyledLabelV2 justify>
                  <div className="name" style={{color:"#005c87"}}>{this.props.t("Set Date and Time")}{<span>*</span>}</div>
                  <div className="radio" style={{ color: "#005c87",width:"auto" }}>
                    <CustomRadioButton
                      // onClick={() => this.changeDateTimeView(showDateTimeInput ? "" : "date")}
                      style={{color:"#005c87",border:"1px solid #669db7", opacity: "0.5", pointerEvents: "none"}}
                      background={"#85c0ea"}
                    >
                      {" "}
                      {showDateTimeInput === "date" && <div></div>}
                    </CustomRadioButton>
                    {this.props.t("All Days")}
                  </div>
                </StyledLabelV2>
                {showDateTimeInput === "date" && (
                  <React.Fragment>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MUICalendarWrapper>
                        <DateTimePicker
                          label="Select Start Date"
                          viewRenderers={{
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                            seconds: renderTimeViewClock,
                          }}
                          sx={{width:"416px",color:"#005C87",borderColor:"#005C87"}}
                          onChange={(value)=>{this.onChangeDate(value?.$d, "date")}}
                          value={date}
                          disablePast={true}
                          // minDate={dayjs().add(1, 'day')}
                          // disabled={launch === 0}
                          slots={{openPickerIcon:CalendarIcon}}
                          
                        />
                      </MUICalendarWrapper>
                    </LocalizationProvider>
                  
                  </React.Fragment>
                )}
                {showDateTimeInput != "date" && (
                  <React.Fragment>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MUICalendarWrapper>
                        <DateTimePicker
                          label="Select Start Date"
                          viewRenderers={{
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                            seconds: renderTimeViewClock,
                          }}
                          sx={{width:"416px",color:"#005C87",borderColor:"#005C87"}}
                          onChange={(value)=>{this.onChangeDate(value?.$d, "date")}}
                          value={date}
                          disablePast={true}
                          maxDateTime={endDate}
                          slots={{openPickerIcon:CalendarIcon}}
                          // slots={{
                          //   openPickerIcon: }}
                          // openPickerButton={}
                          // disabled={launch === 0}
                          
                        />
                        {recurringEvent === recurringTypes[0] ? (<DateTimePicker
                          label="Select end date"
                          viewRenderers={{
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                            seconds: renderTimeViewClock,
                          }}
                          sx={{width:"416px"}}
                          onChange={(value)=>{this.onChangeDate(value?.$d, "endDate")}}
                          value={endDate}
                          disablePast={true}
                          minDateTime={date}
                          slots={{openPickerIcon:CalendarIcon}}
                        />):(
                          <TimePicker
                            label="Select End Time"
                            viewRenderers={{
                              hours: renderTimeViewClock,
                              minutes: renderTimeViewClock,
                              seconds: renderTimeViewClock,
                            }}
                            sx={{width:"416px"}}
                            onChange={(value)=>{this.onChangeDate(value?.$d, "endDate")}}
                            disablePast={true}
                            slots={{openPickerIcon:CalendarIcon}}
                          />
                        )}
                      </MUICalendarWrapper>
                    </LocalizationProvider>
                  </React.Fragment>
                )} */}


                {this.state.showFrequency && <><Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>

                  <StyledLabel margin="0px" marginb="12px">
                    {this.props.t("Set frequency")}{<span>*</span>}
                  </StyledLabel>

                  <RadioButtonWrapper isMargin="12px" width gap>
                    <div className="RadioButtonContainer " onClick={() =>  this.onChangeTimeZone("recurringEvent", "does not repeat")}>
                      <RadioButton
                        id="1"
                        handler={() =>
                          this.onChangeTimeZone(
                            "recurringEvent",
                            "does not repeat"
                          )
                        }
                        type="radio"
                        checked={recurringEvent == "does not repeat"}
                      />
                      <div className="label">{t("Do not repeat")}</div> 
                    </div>

                    {/* <div className="RadioButtonContainer " onClick={() =>  this.onChangeTimeZone("recurringEvent", "weekly")}>
                      <RadioButton
                        id="company"
                        handler={() =>
                          this.onChangeTimeZone("recurringEvent", "weekly")
                        }
                        type="radio"
                        checked={recurringEvent == "weekly"}
                      />
                      <div className="label">{t("Weekly")}</div> 
                    </div> */}
                  </RadioButtonWrapper>

                  {/* <div className="radioButtonDiv">
                    <span
                      onClick={() =>
                        this.onChangeTimeZone("recurringEvent", "does not repeat")
                      }
                    >
                      <RadioButton
                        id="1"
                        handler={() =>
                          this.onChangeTimeZone(
                            "recurringEvent",
                            "does not repeat"
                          )
                        }
                        value={0}
                        isChecked={recurringEvent == "does not repeat"}
                        label={"Do not repeat"}
                        challengeCreate={true}
                        style={{color:"#005c87"}}
                      />
                    </span>
                    <span
                      onClick={() =>
                        this.onChangeTimeZone("recurringEvent", "weekly")
                      }
                    >
                      <RadioButton
                        id="2"
                        handler={() =>
                          this.onChangeTimeZone("recurringEvent", "weekly")
                        }
                        value={1}
                        isChecked={recurringEvent == "weekly"}
                        label={this.props.t("Weekly")}
                        challengeCreate={true}
                        style={{color:"#005c87"}}
                      />
                    </span>
                  </div> */}
                </>}
                {recurringEvent !== recurringTypes[0] &&<Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>}
                {recurringEvent !== recurringTypes[0] && (
                  <>
                    <CommonDropdown
                      createEventUI={true}
                      style={{border: "10px solid black"}}
                      tileContainerStyle={{ width: "100%", margin: "0 0 0px 0",padding:'0px' }}
                      dropdownOpen={this.state.so}
                      dropdownStyle={{ top: "0px" }}
                      labelText={"Number of weeks"}
                      activityDropdownStyle={{ margin: "0 0 00px 0" }}
                      placeholder="Select number of weeks"
                      title={
                        eventLimitValue
                          ? `${eventLimitValue} ${"Weeks"}`
                          : null
                      }
                      id="dropdown-recurring"
                      onClick={() => this.setState({ so: !this.state.so })}
                      data={eventLimits}
                      onSelect={this.onSelectCategory}
                      onSelectParameter={["eventLimitValue", "item"]}
                      active={eventLimitValue}
                      itemValue={false}
                      valueString={"Weeks"}
                      valueIndex={1}
                      selectedClassCategory={eventLimitValue}
                      fontSize={"14px"}
                      dropIcon={true}
                      labelMargin={"0px 0px 0px 0px"}
                    />
                  
                    {/* <CommonDropdown
                    tileContainerStyle={{ width: "100%", margin: "0 0 50px 0" }}
                    dropdownOpen={this.state.so}
                    dropdownStyle={{ top: "30px" }}
                    labelText={""}
                    activityDropdownStyle={{ margin: "0 0 00px 0" }}
                    placeholder="Select Option"
                    title={
                      eventLimitValue
                        ? `${eventLimitValue} ${"Weeks"}`
                        : this.props.t("Select Weeks")
                    }
                    id="dropdown-recurring"
                    onClick={() => this.setState({ so: !this.state.so })}
                    data={eventLimits}
                    onSelect={this.onSelectCategory}
                    onSelectParameter={["eventLimitValue", "item"]}
                    active={eventLimitValue}
                    itemValue={false}
                    valueString={"Weeks"}
                    valueIndex={1}
                  /> */}
                  </>
                )}

                {/* {(companyInfo?.show_spouse || companyInfo?.show_dependent ||  (this.props.locationDetails?.length === 0 && usersToInvite === 2)) && companies?.length > 0 && selectedCompanyCheckBox === 1 && <Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/>}
                <StyledLabel>
                  {this.props.t("Select your email notifications for this event")}
                </StyledLabel>
                <Locationwrapper
                  border
                  background="none"
                  marginTop="0"
                  padding="0"
                >
                  {emailOptionKeys.map((item, index) => (
                    <div className="checkBoxWidth" key={index}>
                      <span style={{color:"#005c87"}}>
                        <CustomRadioButton
                          checked={emailOption[item] === 1}
                          onClick={() => this.onChangeEmail(item)}
                          
                        >
                          {emailOption[item] === 1 && (
                            <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                          )}
                        </CustomRadioButton>
                        {this.props.t("Event")}
                        {item == "launch_event_email"
                          ? this.props.t(" Creation")
                          : item == "event_reminder_email"
                            ? this.props.t(" Reminder")
                            : this.props.t(" Completion")}
                      </span>
                    </div>
                  ))}
                </Locationwrapper> */}
              </div>
            </div>
          </Container>
        </div>
        {showDatePopupModal&&<CustomDateTimePicker showModal={showDatePopupModal} onClose={this.hideCalendarPopup} date={datePopup==="date"? date: endDate} stateDateSelected={ datePopup==="date"?dayjs(new Date()):date} changeDate={this.onChangeDateValue} type={datePopup} />}
      </Layout>
    );
  };

  stepFiveForm = () => {
    const {
      step,
      emailOption,
    } = this.state;
    const {t} = this.props;
    let emailOptionKeys = Object.keys(emailOption);
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87"  paddingForm>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                {<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="0">
                  {t("Email notifications: Select email option for this event")}
                </StyledLabel>}
                <div className="radioButtonDiv">
                  <Locationwrapper background="white" isFlex={'1 1 50%'} style={{flexWrap:"nowrap"}} isWidth="25%" marginTop="12px">
                    {emailOptionKeys.map((item, index) => (
                      <div className="checkBoxWidth" key={index}>
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={emailOption[item] === 1} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={() => this.onChangeEmail(item)}
                            >
                              {emailOption[item] === 1 ? RecognitionTickIcon(): null}
                            </div>
                          </ManagerIconContainer>
                          {t("Event")}
                          {item == "launch_event_email"? t(" Creation"): item == "event_reminder_email"? t(" Reminder"): t(" Completion")}
                        </span>
                      </div>))}           
                  </Locationwrapper>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  render() {
    const {
      title,
      description,
      imgSrc,
      date,
      companies,
      limitUser,
      // time_zone,
      companiesPermission,
      locationPermission,
      step,
      com_location,
      addLimitCheckbox,
      eventLink,
      usersToInvite,
      teams,
      departments,
      selectFlayer,
      flayerName,
      selectedOption,
      eventPointValue,
      buttonStatus,
      eventLimitValue,
      recurringEvent,
      isThemeEvent,
      eventThemePointValue,
      participantingPointValue,
      // iseventUrl
    } = this.state;
    const charCount = description?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')?.trim().length;
    const { isLoading, allCompanies, userCompany, role, /*locationDetails*/ isAccountManager} =
      this.props;
    if (
      (companiesPermission && !allCompanies) ||
      (locationPermission && !userCompany) ||
      isLoading
    ) {
      return <Waiting />;
    }
    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2
            ? (isThemeEvent ? this.stepTwoThemeEventForm() : this.stepTwoForm())
            : step === 3
              ? this.stepThreeForm()
              : step === 4 ? this.stepFourForm() : step === 5 && this.stepFiveForm()}
        {step === 1 && (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description || (charCount > 3000)} onClick={!title||!imgSrc|| !description?null: () => this.updateStep(2)}>
                Next
              </CommonButtonPopup>
              {/* <CommonButton
                btnType={"squareIcon"}
                onClick={() => this.updateStep(2)}
                disabled={!title ||!imgSrc ||!description ||!limitUser||(addLimitCheckbox&&limitUser===0) ||(!location&&!eventLink)}
                title={this.props.t("Next")}
                styles={{marginAuto:"auto",color:"#007AB1" }}
                nextIcon={NextArrows("white")}
                // style={{boxShadow: (!title ||!imgSrc ||!description ||!limitUser||(addLimitCheckbox&&limitUser===0) ||(!location&&!eventLink)) ? "none" : "0px 8px 24px 0px #005C8780"}}
              /> */}
            </Main>
          </ButtonContainer>
        )}
        {step === 2 && (

          isThemeEvent ? (
            <ButtonContainer>
              <div className="wrapper">
               
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(1)}
                  margin="auto auto auto 0px">
                  Back
                </CommonButtonBorder>
  
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"  disabled={(!eventThemePointValue && eventThemePointValue != 0) || (!participantingPointValue && participantingPointValue != 0)}    onClick={() => this.updateStep(3)}>
                  Next
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          ):
            <ButtonContainer>
              <div className="wrapper">
                {/* <CommonButton
                btnType={"squareIcon"}
                styles={{color:"white",textColor:"#007AB1",border:"#007AB1",width:"200px", marginLeft:"0px",display:"flex",justifyContent:"center",alignItems:"center"}}
                onClick={() => this.updateStep(1)}
                title={this.props.t("Go Back")}
                icon={Arrows()}
              /> */}
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(1)}
                  margin="auto auto auto 0px">
                  Back
                </CommonButtonBorder>
                {/* <CommonButton
                btnType={"squareIcon"}
                disabled={!time_zone||!date || (!this.state.selectFlayer && !this.state.flayerName)}
                styles={{marginAuto:"auto",color:"#007AB1" }}
                onClick={() => this.updateStep(3)}
                title={this.props.t("Next")}
                nextIcon={NextArrows("white")}
                // style={{boxShadow:(!time_zone||!date) ? "none" : "0px 8px 24px 0px #005C8780"}}
              /> */}
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={(addLimitCheckbox && !limitUser) ||(!location&&!eventLink) || (selectedOption === 1 && !eventLink) || (!eventPointValue && eventPointValue != 0) || (!selectFlayer && !flayerName)  } onClick={() => this.updateStep(3)}>
                  Next
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
        )}
        {step === 3 && (
          <ButtonContainer>
            <div className="wrapper">
              {/* <CommonButton
                btnType={"squareIcon"}
                styles={{color:"white",textColor:"#007AB1",border:"#007AB1",width:"200px", marginLeft:"0px",display:"flex",justifyContent:"center",alignItems:"center"}}
                onClick={() => this.updateStep(2)}
                title={this.props.t("Go Back")}
                icon={Arrows()}
              /> */}
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(2)}
                margin="auto auto auto 0px">
                {/* {AdminLeftArrowIcon("#F37A65")} */}
                Back
              </CommonButtonBorder>
              {/* <CommonButton
                btnType={"squareIcon"}
                disabled={ !companies.length > 0 && (role === "ADMIN"||isAccountManager)|| companies.length === 0 || (usersToInvite === 2 && !com_location.length > 0) || (usersToInvite === 1 && !departments.length > 0) || (usersToInvite === 3 && !teams.length > 0)}
                styles={{marginAuto:"auto",color:"#007AB1" }}
                onClick={() => this.updateStep(4)}
                title={this.props.t("Next")}
                nextIcon={NextArrows("white")}
              /> */}
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"                
                disabled={ !companies.length > 0 && (role === "ADMIN"||isAccountManager)|| companies.length === 0 || (usersToInvite === 2 && !com_location.length > 0) || (usersToInvite === 1 && !departments.length > 0) || (usersToInvite === 3 && !teams.length > 0)}
                onClick={() => this.updateStep(4)}>
                Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}
        {step === 4 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(3)}
                margin="auto auto auto 0px">
                {/* {AdminLeftArrowIcon("#F37A65")} */}
                Back
              </CommonButtonBorder>
              {/* <CommonButton
                btnType={"squareIcon"}
                styles={{color:"white",textColor:"#007AB1",border:"#007AB1",width:"200px", marginLeft:"0px",display:"flex",justifyContent:"center",alignItems:"center"}}
                onClick={() => this.updateStep(3)}
                title={this.props.t("Go Back")}
                icon={Arrows()}
              /> */}
              {/* <CommonButton
                btnType={"squareIcon"}
                styles={{color:"#007AB1", marginAuto:'auto'}}
                // onClick={this.saveEvent}
                title={this.props.t("Save Changes")}
                onClick={() => this.updateStep(5)}
                // style={{boxShadow: "0px 8px 24px 0px #005C8780"}}
              /> */}
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={buttonStatus || !date || ( this.state.showFrequency && !this.state.endDate && showDateTimeInput != "date") || (recurringEvent == "weekly" && !eventLimitValue)} onClick={buttonStatus || ( this.state.showFrequency && !this.state.endDate && showDateTimeInput != "date") || (recurringEvent == "weekly" && !eventLimitValue)?null: () => this.updateStep(5)}>
                Next
                {/* {buttonStatus || ( this.state.showFrequency && !this.state.endDate)? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()} */}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}

        {step === 5 && (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(4)}
                margin="auto auto auto 0px">
                {/* {AdminLeftArrowIcon("#F37A65")} */}
                Back
              </CommonButtonBorder>
              <CommonButtonPopup margin="auto 0 auto auto" width="200px" height="48px" 
                disabled={buttonStatus || ( this.state.showFrequency && !this.state.endDate && showDateTimeInput != "date")} onClick={!buttonStatus? () => this.saveEvent():null}>
              Save Changes
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

EditEvent.propTypes = {
  createEvent: PropTypes.func.isRequired,
  getPlacesAction: PropTypes.func.isRequired,
  places: PropTypes.array,
  isLoading: PropTypes.bool,
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  fetchAllCompanies: PropTypes.func.isRequired,
  allCompanies: PropTypes.array,
  fetchCompanyForUser: PropTypes.func.isRequired,
  userCompany: PropTypes.object,
  eventDetail: PropTypes.object,
  EditEventAction: PropTypes.func,
  locationDetails: PropTypes.array,
  companyDetails: PropTypes.object,
  userPermissions: PropTypes.array,
  getCompanyLocation: PropTypes.func,
  t: PropTypes.func,
  getCompanyDepartment:PropTypes.func,
  departmentDetails:PropTypes.array,
  isAccountManager:PropTypes.bool,
  EventDetailsById:PropTypes.func,
  allRoles: PropTypes.array 
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  eventDetail: state.events.eventDetail,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  departmentDetails: state.register.departmentDetails,
  allRoles: state.profileData.allRoles,
});

const mapDispatchToProps = (dispatch) => ({
  EventDetailsById: (id) => dispatch(getEventDetailsById(id)),
  fetchAllCompanies: () => dispatch(getAllCompanies()),
  fetchCompanyForUser: () => dispatch(getUserCompanyDetails()),
  EditEventAction: (data) => dispatch(EditEventAction(data)),
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id))
});

export default connect(mapStateToProps, mapDispatchToProps)((withTranslation())(EditEvent));
